<!-- 获取产品 -->
<template>
  <article
    class="product-get"
    :class="{ whiteBg: showWhiteBg }"
    :style="{ 'background-image': !showWhiteBg ? `url(${bgImage})` : '' }"
  >
    <div class="product-get-wrapper" :style="{ width: width + 'px' }">
      <header
        class="product-get-header"
        v-scroll-animate="{
          animation: 'fadeInUp',
        }"
      >
        {{ title }}
      </header>
      <h4
        class="product-get-subTitle"
        v-scroll-animate="{
          animation: 'fadeInUp',
          delay: 200,
        }"
      >
        {{ subTitle }}
      </h4>
      <footer class="product-get-footer">
        <button
          class="product-get-btn"
          v-if="contactBtn && contactBtn.label"
          @click="openContractUsModal"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 350,
          }"
        >
          {{ contactBtn.label }}
        </button>
        <button
          :loading="loading"
          class="product-get-btn"
          @click="downLoad"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 300,
          }"
          v-if="downLoadBtn && downLoadBtn.label && downLoadBtn.show"
        >
          {{ downLoadBtn.label }}
        </button>
      </footer>
    </div>

    <ContractUsModal
      v-if="contractVisible"
      :contractVisible.sync="contractVisible"
    ></ContractUsModal>
  </article>
</template>

<script>
import { downLoadFile } from "@/api/api";
import ContractUsModal from "@/components/ContractUsModal.vue";
export default {
  name: "ProductGet",
  components: {
    ContractUsModal,
  },
  props: {
    title: {
      type: String,
      default: "Infrastructure Operation and Maintenance Digital Twin Solution",
    },
    subTitle: {
      type: String,
      default:
        "Bringing a new model to the operation and maintenance management of roadways, waterways, and city infrastructure!",
    },
    bgImage: {
      type: String,
      default: () => require("@/assets/images/dtwin/getNow_bg.png"),
    },
    downLoadBtn: {
      type: Object,
      default: () => {
        return {
          label: "下载产品手册",
          fileUrl: "",
          show: true,
          action: "downLoad", // link or download
        };
      },
    },
    contactBtn: {
      type: Object,
      default: () => {
        return {
          label: "让销售人员联系您",
        };
      },
    },
    width: {
      type: Number,
      default: 1200,
    },
    showWhiteBg: {
      type: Boolean,
      default: false, // 白色背景，权限大于bgImage
    },
  },
  data() {
    return {
      loading: false,
      contractVisible: false,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    downLoad() {
      if (this.downLoadBtn.action && this.downLoadBtn.action === "downLoad") {
        if (!this.downLoadBtn.fileUrl) return;
        this.loading = true;
        downLoadFile(this.downLoadBtn.fileUrl)
          .then((res) => {
            let fileName = this.$uniFun.getFileName(this.downLoadBtn.fileUrl);
            this.$uniFun.downloadFile(res, fileName);
          })
          .catch((e) => {
            this.$message.error("资源请求错误");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        let url = this.downLoadBtn.fileUrl || "/download?anchor=software";
        this.$uniFun.openInCurrentTab(url);
      }
    },
    openContractUsModal() {
      this.contractVisible = true;
    },
  },
};
</script>

<style lang="scss">
.product-get {
  width: 100%;
  height: 200px;
  // background: url("~@/assets/images/dtwin/getNow_bg.png") no-repeat center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 200px;
  color: #fff;
  .product-get-wrapper {
    width: 1200px;
    margin: 0 auto;
    padding: 32px 0;
    text-align: center;
  }
  .product-get-header {
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 24px;
    color: #fff;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .product-get-subTitle {
    margin-bottom: 24px;
    font-weight: 400;
    font-size: 16px;
    color: #fff;
    line-height: 27px;
    text-align: justify;
    font-style: normal;
  }
  .product-get-footer {
    text-align: left;
    .product-get-btn {
      padding: 8px 24px;
      font-size: 14px;
      color: #000;
      text-align: center;
      background: #fff;
      border-radius: 2px;
      &:first-child {
        margin-right: 20px;
      }
      &:hover {
        cursor: pointer;
        opacity: 0.8 !important;
      }
    }
  }
}
.product-get.whiteBg {
  .product-get-header,
  .product-get-subTitle {
    color: #333333;
  }
  .product-get-btn {
    border: 1px solid #666666;
  }
}
</style>
